//#region imports
import customAxios from '../../utils/customAxios';
import { formatDateDDMMYYYY } from '../../utils/dateFormat';
import React, { useState, useEffect } from 'react';

import { DataGridPro } from '@mui/x-data-grid-pro';

import ModalCCDelete from '../Modal/Delete/ModalCCDelete';
import { Tooltip } from '@mui/material';

import { Stack } from '@mui/system';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAdd,
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
} from '@fortawesome/free-solid-svg-icons';

import { DeleteOutlineOutlined as DeleteIcon } from '@mui/icons-material';

import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';

import ModalCCUpdate from '../Modal/Update/ModalCCUpdate';
import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import ModalCC from '../Modal/Create/ModalCC';
import { GlobalVariables } from '../../globalVar';

import ClientFilter from '../Utils/ClientFilter';
import { useTableLocale } from '../../hooks/useTableLocale';
import { useUserPermissions } from '../../hooks/userPermissions';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
);

//#endregion

export const ClientContactsTableAxios = () => {
  const userPermissions = useUserPermissions();
  // Config de hooks
  const [clientContactData, setClientContactData] = useState([]);
  const [selectedClients, setSelectedClients] = useState('all');

  const [isLoading, setIsLoading] = useState(true);

  const { t } = useTranslation();

  const {
    contactsString,
    contactContactNameString,
    contactEmailString,
    contactPhoneString,
    contactTypeString,
    contactClientString,
    contactSiteString,
    contactStatusString,
    contactEDateString,
    noContactsString,
    noSClientsContacts,
    addString,
    detailString,
    editString,
    deleteString,
    createdAtString,
    createdByString,
    updatedAtString,
    updatedByString,
    notesString,
    jobString,
  } = useTranslationHook();

  const [modalClientCShow, setModalClientCShow] = useState(false);
  const [modalCCUpdateShow, setModalCCUpdateShow] = useState(false);
  const [modalCCDeleteShow, setModalCCDeleteShow] = useState(false);

  const locale = useTableLocale();

  useEffect(() => {
    const updateClientContactData = () => {
      setClientContactData((prevData) => {
        return prevData.map((contact) => ({
          ...contact,
          is_active: t(`${contact.is_active}`),
        }));
      });
    };
    i18next.on('languageChanged', updateClientContactData);

    return () => {
      i18next.off('languageChanged', updateClientContactData);
    };
  }, [t]);

  useEffect(() => {
    let endpoint = `${GlobalVariables.getURL()}listClientsContacts?id=${selectedClients}`;

    getData(endpoint);
  }, [selectedClients]);

  const getData = async (endpoint) => {
    setIsLoading(true);

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      if (response.status === 204) {
        setClientContactData([]);
      } else {
        const clientContactData = response.data.contacts.map(
          (contact, index) => {
            return {
              ...contact,
              id: `${contact.id}-${contact.site_name}-${index}`,
              contactIdOriginal: contact.id,
              is_active: t(`${contact.is_active}`),
            };
          },
        );

        setClientContactData(clientContactData);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // No necesitas hacer nada en este efecto.
  }, [isLoading]);

  function manageContactUpdate(contactInfo) {
    return new Promise((resolve, reject) => {
      var contactId = contactInfo.contactIdOriginal; // Utiliza contactIdOriginal en lugar de id
      localStorage.setItem('contactIdToUpdate', contactId);

      customAxios
        .get(`${GlobalVariables.getURL()}autofillContact/${contactId}`, {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        })
        .then((response) => {
          var contactData = response.data;
          var contactEmailForUpdate = contactData.contact_info.email;
          localStorage.setItem('contactEmailForUpdate', contactEmailForUpdate);
          var contactNameForUpdate = contactData.contact_info.name;
          localStorage.setItem('contactNameForUpdate', contactNameForUpdate);
          var contactPhoneForUpdate = contactData.contact_info.telefono;
          localStorage.setItem('contactPhoneForUpdate', contactPhoneForUpdate);
          var contactCountryCodeForUpdate =
            contactData.contact_info.countryCode;
          localStorage.setItem(
            'contactCountryCodeForUpdate',
            contactCountryCodeForUpdate,
          );
          var contactLastNameForUpdate = contactData.last_names;
          localStorage.setItem(
            'contactLastNameForUpdate',
            contactLastNameForUpdate,
          );
          var contactTypeForUpdate = contactData.contact_info.type;
          if (contactTypeForUpdate === 'Principal') {
            localStorage.setItem('contactTypeForUpdate', 1);
          } else {
            localStorage.setItem('contactTypeForUpdate', 2);
          }
          var contactJobForUpdate = contactData.contact_info.job;
          localStorage.setItem('contactJobForUpdate', contactJobForUpdate);
          var contactNotesForUpdate = contactData.contact_info.notes;
          localStorage.setItem('contactNotesForUpdate', contactNotesForUpdate);

          var contactClientForUpdate = contactData.contact_info.business_name;
          localStorage.setItem(
            'contactClientForUpdate',
            contactClientForUpdate,
          );
          var contactSiteForUpdate = contactData.contact_info.site_name;
          localStorage.setItem('contactSiteForUpdate', contactSiteForUpdate);

          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  function manageContactDelete(contactInfo) {
    var contactId = contactInfo.id;
    localStorage.setItem('contactIdToDelete', contactId);

    var contactEmail = contactInfo.email;
    var contactBusiness = contactInfo.business_name;
    var contactCreatedDate = contactInfo.created_at;
    var contactName = contactInfo.name + ' ' + contactInfo.last_names;
    localStorage.setItem('contactNameToDelete', contactName);
    localStorage.setItem('contactEmailToDelete', contactEmail);
    localStorage.setItem('contactCreatedDateToDelete', contactCreatedDate);
    localStorage.setItem('contactBusinessToDelete', contactBusiness);
  }

  const actionColumn = [
    {
      field: 'action',
      headerName: detailString,
      width: 120,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {userPermissions.includes('Update Contact') && (
              <Tooltip title={editString} arrow>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '5px',
                  }}
                  onClick={async () => {
                    try {
                      await manageContactUpdate(params.row);
                      setModalCCUpdateShow(true);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  <ModeEditOutlineOutlinedIcon
                    className="detail-icons"
                    id="update-icon"
                  />
                </button>
              </Tooltip>
            )}
            {userPermissions.includes('Delete Contact') && (
              <Tooltip title={deleteString} arrow>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '5px',
                  }}
                  onClick={() => {
                    setModalCCDeleteShow(true);
                    manageContactDelete(params.row);
                  }}
                >
                  <DeleteIcon className="detail-icons" id="delete-icon" />
                </button>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  // Columnas
  const clientContactColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 100,
    },
    {
      field: 'business_name',
      headerName: contactClientString,
      width: 180,
    },
    {
      field: 'site_name',
      headerName: contactSiteString,
      width: 180,
    },
    {
      field: 'full_name',
      headerName: contactContactNameString,
      width: 250,
      renderCell: (params) => {
        var full_name = params.row.name + ' ' + params.row.last_name;
        return (
          <div>
            <span>{full_name}</span>
          </div>
        );
      },
    },
    {
      field: 'email',
      headerName: contactEmailString,
      width: 200,
    },
    {
      field: 'telefono',
      headerName: contactPhoneString,
      width: 200,
    },
    {
      field: 'is_active',
      headerName: contactStatusString,
      width: 150,
      renderCell: (params) => {
        if (
          params.row.is_active === 'Activo' ||
          params.row.is_active === 'Active'
        ) {
          return (
            <div>
              <span className="statusActive">{params.row.is_active}</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="statusInactive">{params.row.is_active}</span>
            </div>
          );
        }
      },
      valueGetter: (params) => params.row.is_active,
    },
    {
      field: 'type',
      headerName: contactTypeString,
      width: 180,
    },
    {
      field: 'job',
      headerName: jobString,
      width: 150,
    },
    {
      field: 'created_at',
      headerName: createdAtString,
      width: 150,
    },
    {
      field: 'created_by',
      headerName: createdByString,
      width: 150,
    },
    {
      field: 'updated_at',
      headerName: updatedAtString,
      width: 150,
    },
    {
      field: 'updated_by',
      headerName: updatedByString,
      width: 150,
    },
    {
      field: 'notes',
      headerName: notesString,
      width: 200,
    },
    // Map through all columns and add default renderCell if not already defined
  ].map((col) =>
    col.renderCell
      ? col
      : {
          ...col,
          renderCell: (params) =>
            ['created_at', 'updated_at'].includes(col.field)
              ? formatDateDDMMYYYY(params.row[col.field])
              : params.row[col.field] || '-',
        },
  );

  return (
    <>
      <div className="datatable-btns-container">
        <div className="dt-btn-main-container">
          <span className="dabiWebText"> {contactsString} </span>
          {userPermissions.includes('Create Contact') && (
            <button
              className="add-button create-contact-tour"
              onClick={() => setModalClientCShow(true)}
            >
              {addString} <FontAwesomeIcon icon={faAdd} />
            </button>
          )}
        </div>
      </div>

      <ModalCC
        show={modalClientCShow}
        onHide={() => setModalClientCShow(false)}
        getContacts={getData}
        selectedClients={selectedClients}
      />

      <ModalCCDelete
        show={modalCCDeleteShow}
        onHide={() => setModalCCDeleteShow(false)}
        getContacts={getData}
        selectedClients={selectedClients}
      />

      <ModalCCUpdate
        show={modalCCUpdateShow}
        onHide={() => setModalCCUpdateShow(false)}
        getContacts={getData}
        selectedClients={selectedClients}
      />

      <DataGridPro
        localeText={locale.components.MuiDataGrid.defaultProps.localeText}
        pagination
        loading={isLoading}
        initialState={{
          sorting: {
            sortModel: [
              { field: 'business_name', sort: 'asc' },
              { field: 'site_name', sort: 'asc' },
              { field: 'full_name', sort: 'asc' },
            ],
          },
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
          pinnedColumns: { right: ['action'] },
        }}
        rows={clientContactData}
        columns={clientContactColumns.concat(actionColumn)}
        disableSelectionOnClick
        checkboxSelection
        slots={{
          noRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              {selectedClients.length === 0
                ? noSClientsContacts
                : noContactsString}
            </Stack>
          ),
          toolbar: () => (
            <ClientFilter
              selectedClients={selectedClients}
              setSelectedClients={setSelectedClients}
            />
          ),
        }}
      />
    </>
  );
};
